export default {"src":"/_next/static/media/AEHR.b0b1151d.svg","height":18,"width":18};